import { EntitiesStructure, SeoInterface } from 'common/types/Page'
import {
  BaseEntityInterface,
  EntityInnerItemInterface,
  EntityUnionType,
} from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { GoogleFontProperties } from 'common/utils/fontsUtils'
import { CREATE_POPUP_STRUCTURE, UPDATE_ENTITIES } from 'client/actionTypes'
import { PagesInterface } from 'client/db/tables/pages'
import {
  ADD_STRUCTURE,
  AddStructureAction,
  FIX_ENTITIES,
  FixEntities,
  REMOVE_ENTITY,
  REMOVE_ENTITY_BY_ID_AND_PARENT_ID,
  RemoveEntityAction,
  RemoveEntityByIdAndPArentIdAction,
  TOGGLE_INSTANT_UPLOAD,
  TOGGLE_SETTINGS,
  ToggleInstantUpload,
  ToggleSettings,
  UPDATE_SEO_PROPERTY,
  UPDATE_ENTITY,
  UPDATE_GLOBAL_SETTINGS,
  UPDATE_PAGE_FROM_DB,
  UpdateSeoPropertyAction,
  UpdateEntityAction,
  UpdateGlobalSettings,
  UpdatePageFromDbAction,
  UpdateEntitiesAction,
} from './pageActionTypes'

export const updateSeoProperty =
  <T extends keyof SeoInterface>(property: T) =>
  (value: SeoInterface[T]): UpdateSeoPropertyAction<T> => {
    return {
      type: UPDATE_SEO_PROPERTY,
      payload: { property, value },
    }
  }

export function updatePageFromDb(
  data: PagesInterface['page'],
): UpdatePageFromDbAction {
  return {
    type: UPDATE_PAGE_FROM_DB,
    payload: data,
  }
}

export function updateEntity<T>(entity: T): UpdateEntityAction<T> {
  return {
    type: UPDATE_ENTITY,
    payload: entity,
  }
}

export function updateEntities<T extends Record<string, EntityUnionType>>(
  entities: T,
): UpdateEntitiesAction<T> {
  return {
    type: UPDATE_ENTITIES,
    payload: entities,
  }
}

export function updateEntityInnerItem<T>(entity: T): UpdateEntityAction<T> {
  return {
    type: UPDATE_ENTITY,
    payload: entity,
  }
}

export function addStructure(
  structure: Record<
    string,
    OldEntityInterface | EntityInnerItemInterface | BaseEntityInterface
  >,
): AddStructureAction {
  return {
    type: ADD_STRUCTURE,
    payload: structure,
  }
}

export function removeEntity<T>(entity: T): RemoveEntityAction<T> {
  return {
    type: REMOVE_ENTITY,
    payload: entity,
  }
}

export function removeEntityByIdAndParentId(
  id: string,
  parentId: string,
): RemoveEntityByIdAndPArentIdAction {
  return {
    type: REMOVE_ENTITY_BY_ID_AND_PARENT_ID,
    payload: {
      parentId,
      id,
    },
  }
}

export function updateGlobalSettings(
  globalSettings: GoogleFontProperties,
): UpdateGlobalSettings {
  return {
    type: UPDATE_GLOBAL_SETTINGS,
    payload: globalSettings,
  }
}

export function toggleInstantUpload(): ToggleInstantUpload {
  return {
    type: TOGGLE_INSTANT_UPLOAD,
    payload: true,
  }
}

export function toggleSettings(id: string): ToggleSettings {
  return {
    type: TOGGLE_SETTINGS,
    payload: { id },
  }
}

export function fixEntities(entities: EntitiesStructure): FixEntities {
  return {
    type: FIX_ENTITIES,
    payload: entities,
  }
}

export const createPopupStructure = (structure: {
  [id: string]:
    | EntityInnerItemInterface
    | BaseEntityInterface
    | OldEntityInterface
}) => {
  return {
    type: CREATE_POPUP_STRUCTURE,
    payload: structure,
  }
}

export type PageActions =
  | FixEntities
  | ToggleSettings
  | ToggleInstantUpload
  | UpdateGlobalSettings
  | RemoveEntityByIdAndPArentIdAction
  | RemoveEntityAction<any> // The 'any' can be replaced by a more specific type if possible
  | AddStructureAction
  | UpdateEntityAction<any> // The 'any' can be replaced by a more specific type if possible
  | UpdateEntitiesAction<Record<string, EntityUnionType>> // The 'any' can be replaced by a more specific type if possible
  | UpdatePageFromDbAction
